import React from "react";

/* Pagination Component 
-------------------------------------------------*/

// const propTypes = {
//   items: React.PropTypes.array.isRequired,
//   onChangePage: React.PropTypes.func.isRequired,
//   initialPage: React.PropTypes.number
// }

const defaultProps = {
  initialPage: 1,
  pageSize: 10,
  onPageChange: undefined,
};

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pager: {},
      itemsSignature: this.createItemsSignature(props.items || []),
    };
  }

  componentWillMount() {
    // set page if items array isn't empty
    if (this.props.items && this.props.items.length) {
      this.setPage(this.props.initialPage);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // reset page if items array has changed
    const itemsSignature = this.createItemsSignature(this.props.items || []);
    const pageSizeChanged = this.props.pageSize !== prevProps.pageSize;
    const itemsChanged = itemsSignature !== this.state.itemsSignature;

    if (!pageSizeChanged && !itemsChanged) {
      return;
    }

    const currentPager = this.state.pager || {};
    const desiredPage = pageSizeChanged
      ? this.props.initialPage
      : currentPager.currentPage || this.props.initialPage;

    this.setPage(desiredPage);
  }

  createItemsSignature(items = []) {
    if (!Array.isArray(items) || !items.length) {
      return "";
    }

    return items
      .map((item, index) => {
        if (item && typeof item === "object") {
          if (item.paginationId !== undefined && item.paginationId !== null) {
            return `${item.paginationId}`;
          }
          if (item.id !== undefined && item.id !== null) {
            return `${item.id}`;
          }
          if (item.user_id !== undefined && item.user_id !== null) {
            return `${item.user_id}`;
          }
        }
        return `${index}-${item}`;
      })
      .join("|");
  }

  setPage(page) {
    const items = Array.isArray(this.props.items) ? this.props.items : [];
    const existingPager = this.state.pager || {};
    const effectivePageSize =
      this.props.pageSize || existingPager.pageSize || defaultProps.pageSize;
    const totalPages = Math.ceil(items.length / effectivePageSize);

    let nextPage = page;
    if (!totalPages) {
      nextPage = 1;
    } else {
      nextPage = Math.min(Math.max(nextPage || 1, 1), totalPages);
    }

    // get new pager object for specified page
    const pager = this.getPager(items.length, nextPage, this.props.pageSize);

    // get new page of items from items array
    const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

    // update state
    this.setState({
      pager,
      itemsSignature: this.createItemsSignature(items),
    });

    // call change page function in parent component
    if (typeof this.props.onChangePage === "function") {
      this.props.onChangePage(pageOfItems, pager);
    }
  }

  getPager(totalItems, currentPage, pageSize) {
    // default to first page
    currentPage = currentPage || 1;

    // default page size is 10
    pageSize = pageSize || 10;

    // calculate total pages
    var totalPages = Math.ceil(totalItems / pageSize);

    var startPage, endPage;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    // calculate start and end item indexes
    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    var pages = [...Array(endPage + 1 - startPage).keys()].map(
      (i) => startPage + i
    );

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
    };
  }

  render() {
    var pager = this.state.pager;

    if (!pager.pages || pager.pages.length <= 1) {
      // don't display pager if there is only 1 page
      return null;
    }

    return (
      <ul className="pagination">
        <li
          className={pager.currentPage === 1 ? "disabled" : ""}
          style={{
            listStyle: "none",
          }}
        >
          <span onClick={() => this.setPage(1)}>First</span>
        </li>
        <li className={pager.currentPage === 1 ? "disabled" : ""}>
          <span onClick={() => this.setPage(pager.currentPage - 1)}>Previous</span>
        </li>
        {pager.pages.map((page, index) => (
          <li
            key={index}
            className={pager.currentPage === page ? "active" : ""}
          >
            <span onClick={() => this.setPage(page)}>{page}</span>
          </li>
        ))}
        <li
          className={pager.currentPage === pager.totalPages ? "disabled" : ""}
        >
          <span onClick={() => this.setPage(pager.currentPage + 1)}>Next</span>
        </li>
        <li
          className={pager.currentPage === pager.totalPages ? "disabled" : ""}
        >
          <span onClick={() => this.setPage(pager.totalPages)}>Last</span>
        </li>
      </ul>
    );
  }
}

// Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;

/* App Component 
-------------------------------------------------*/

class PaginationContainer extends React.Component {
  // constructor() {
  //     super();

  //     // an example array of items to be paged
  //     var exampleItems = [...Array(150).keys()].map(i => ({ id: (i+1), name: 'Item ' + (i+1) }));

  //     this.state = {
  //         exampleItems: exampleItems,
  //         pageOfItems: []
  //     };

  //     // bind function in constructor instead of render (https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/jsx-no-bind.md)
  //     this.onChangePage = this.onChangePage.bind(this);
  // }
  state = {
    pageOfItems: [],
    pager: null,
  };

  componentDidMount() {}

  onChangePage = (pageOfItems, pager) => {
    // update state with new page of items
    this.setState({ pageOfItems: pageOfItems, pager });
    if (typeof this.props.onPageChange === 'function') {
      this.props.onPageChange(pageOfItems, pager);
    }
  };

  render() {
    return (
      <div>
        {this.state.pageOfItems.map(this.props.renderItem)}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Pagination
            items={this.props.items}
            onChangePage={this.onChangePage}
            pageSize={this.props.pageSize}
            initialPage={this.props.initialPage}
          />
        </div>
      </div>
    );
  }
}

export default PaginationContainer;
